<template>
    <div>
        <div>
            <h1>COD认证</h1>
            <p>การใช้บริการ COD ลูกค้าต้องสมัครใช้งาน COD ด้วยข้อมูลบัตรประชาชนและบัญชีธนาคาร เพื่อใช้ในการรับเงินคืน
                โดยมีได้เพียง 1 บัญชี และชื่อบัญชีจะต้องตรงกับชื่อบนบัตรประชาชนที่ได้ทำการลงทะเบียนในระบบเท่านั้น</p>
            <b-button variant="link" @click="ProtocolPrivacy = true">COD信息认证安全隐私协议</b-button>
        </div>
        <div>
            <b-form @submit="onSubmit">
                <b-form-group
                    label="电话号码"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        v-model="ruleForm.accountTel"
                        placeholder="กรุณาเข้า"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="认证用户类型"
                    label-for="input-1"
                >
                    <b-form-radio-group
                        id="radio-group-1"
                        v-model="ruleForm.codCertType"
                        :options="options"
                        name="radio-options"
                    ></b-form-radio-group>
                </b-form-group>

                <div v-if="ruleForm.codCertType == '1'">
                    <b-form-group
                        label="证件类型"
                        label-for="input-1"
                    >
                        <b-form-radio-group
                            id="radio-group-2"
                            v-model="ruleForm.certType"
                            :options="options1"
                            name="radio-options1"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                        :label=" ruleForm.certType == 1 ? '身份证姓名' : '护照姓名'"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.idCardName"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        :label="ruleForm.certType == 1 ? '身份证号码' : '护照号码'"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.idCardNum"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="账户姓名"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.accountName"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="存折账号"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.passbookNum"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="所属银行"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.passbookBank"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="电子邮箱"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.passbookEmail"
                            placeholder="กรุณาเข้า"
                            type="email"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        :label="ruleForm.certType == 1 ? '身份证正面照片' : '护照照片'"
                        label-for="input-1"
                    >
                        <upload style="width: 300px" @updateImage="updateImage" :imageUrl="imgUrl"></upload>
                    </b-form-group>

                    <b-form-group
                        label="存折照片"
                        label-for="input-1"
                    >
                        <upload style="width: 300px" @updateImage="updateImage1" :imageUrl="imgUrl"></upload>
                    </b-form-group>
                </div>


                <div v-if="ruleForm.codCertType == 2">
                    <b-form-group
                        label="公司名称"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.companyName"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="公司税号"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.companyNum"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="联系人名称"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.contactName"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="账户姓名"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.accountName"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="存折账号"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.passbookNum"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="所属银行"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            v-model="ruleForm.passbookBank"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="电子邮箱"
                        label-for="input-1"
                    >
                        <b-form-input
                            id="input-1"
                            type="email"
                            v-model="ruleForm.passbookEmail"
                            placeholder="กรุณาเข้า"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="企业注册证书"
                        label-for="input-1"
                    >
                        <upload style="width: 300px" @updateImage="updateImage2" :imageUrl="imgUrl2"></upload>
                    </b-form-group>

                    <b-form-group
                        label="公司法人代表"
                        label-for="input-1"
                    >
                        <upload style="width: 300px" @updateImage="updateImage" :imageUrl="imgUrl"></upload>
                    </b-form-group>

                    <b-form-group
                        label="税务证书"
                        label-for="input-1"
                    >
                        <upload style="width: 300px" @updateImage="updateImage4" :imageUrl="imgUrl4"></upload>
                    </b-form-group>

                    <b-form-group
                        label="存折照片"
                        label-for="input-1"
                    >
                        <upload style="width: 300px" @updateImage="updateImage1" :imageUrl="imgUrl1"></upload>
                    </b-form-group>
                </div>

                <b-button type="submit" variant="primary">Submit</b-button>

                <div class="mt-3">
                    <p style="color:#F56C6C;line-height:24px;"><span style="color:#F56C6C;font-weight:600;">公司会按照以上 COD 信息进行COD 回款， 请再次为客户检查信息是否正确</span><br>
                        1. 银行账户名称与身份证名称（或公司名称）必须一致<br>
                        2. 上传图片必须清晰<br>
                        3. 电话号码和邮箱必须正确<br>
                        4. 银行信息必须正确</p>
                </div>
            </b-form>
        </div>

        <b-modal
            centered
            hide-footer
            v-model="ProtocolPrivacy"
            size="lg"
            title="COD信息认证安全隐私协议"
        >
            <div class="noticeContent">
                <!-- <h3>{{$t('codCert.codCertLink')}}</h3> -->
                <li>การใช้บริการ COD ลูกค้าต้องสมัครใช้งาน COD ด้วยข้อมูลบัตรประชาชนและบัญชีธนาคาร
                    เพื่อใช้ในการรับเงินคืน โดยมีได้เพียง 1 บัญชี
                    และชื่อบัญชีจะต้องตรงกับชื่อบนบัตรประชาชนที่ได้ทำการลงทะเบียนในระบบเท่านั้น
                </li>
                <li>หากมีการกรอกข้อมูลเข้ามาใหม่ จะต้องรอจนกว่าข้อมูลใหม่ได้รับการยืนยันก่อนถึงจะสามารถใช้งานได้</li>
                <li>เมื่อลูกค้ากรอกข้อมูลครบถ้วนแล้วและกดยืนยัน สามารถดำเนินการส่งพัสดุ COD ได้ทันที ทาง Mysave
                    จะทำการตรวจสอบเอกสารประมาณ 1-2 วันทำการ หากข้อมูลผิดพลาดจะมีเจ้าหน้าที่ของทาง Mysave
                    ติดต่อเข้าไปเพื่อขอให้กรอกข้อมูลใหม่ หากข้อมูลผิดพลาดจะไม่สามารถโอนเงิน COD คืนให้ท่านได้
                </li>
                <li>เงื่อนไขการรับเงิน COD (Cash On Delivery) หลังจากผู้ให้บริการได้รับโอนเงิน COD จากบริษัทขนส่งแล้ว
                    ผู้ให้บริการจะนำส่งเงิน COD คืนให้กับผู้ส่งสินค้าในวันทำการถัดไปโดยไม่มีดอกเบี้ย ยกเว้น วันอาทิตย์
                    และวันหยุดนักขัตฤกษ์
                </li>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <b-button
                    class="px-5"
                    variant="primary"
                    @click="ProtocolPrivacy = false"
                >
                    ยืนยัน
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import upload from '@/views/newPages/upload.vue'
import {certAgentSender} from "@/api/storeManage";
import {certAgentCodInfoAndType} from "@/api/cod";

export default {
    components: {
        upload
    },
    data() {
        return {
            ProtocolPrivacy: false,
            imgUrl5: '',
            imgUrl4: '',
            imgUrl3: '',
            imgUrl2: '',
            imgUrl1: '',
            imgUrl: '',
            ruleForm: {
                certType: '1',
                codCertType: '1',
            },
            options1: [
                {text: '身份证', value: '1'},
                {text: '护照', value: '2'}
            ],
            options: [
                {text: '个人用户', value: '1'},
                {text: '企业用户', value: '2'}
            ]
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            console.log(this.ruleForm)
            let imgTips = ''
            if (this.ruleForm.certType == 1) {
                if (!this.ruleForm.cardholderPic) {
                    imgTips = this.codCertType == 1 ? '请上传身份证正面照片' : '请上传护照照片'
                }
                if (!this.ruleForm.passportPic) {
                    imgTips = '请上传存折照片'
                }
            } else {
                if (!this.ruleForm.cardholderPic) {
                    imgTips = '请上传公司法人代表照片'
                }
                if (!this.ruleForm.TaxfileCertificatePic) {
                    imgTips = '请上传税务证书'
                }
                if (!this.ruleForm.companyCertificatePic) {
                    imgTips = '请上传企业注册证书'
                }
                if (!this.ruleForm.passportPic) {
                    imgTips = '请上传存折照片'
                }

            }
            if (imgTips) {
                this.$bvModal.msgBoxOk(imgTips, {
                    title: "ERROR",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "คำใบ้",
                    contentClass: "modal-errors",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                });
                return
            }

            let data = {
                bankCode: this.ruleForm.passbookNum,
                bankFile: this.ruleForm.passbookPic,
                bankHolder: this.ruleForm.accountName,
                bankName: this.ruleForm.passbookBank,
                certMobile: this.ruleForm.accountTel,
                codEmail: this.ruleForm.passbookEmail,
                id: this.ruleForm.id == "" ? "" : this.ruleForm.id,

                companyCertificatePic: this.ruleForm.companyCertificatePic,
                companyName: this.ruleForm.companyName,
                companyTaxCode: this.ruleForm.companyNum,
                taxFile: this.ruleForm.TaxfileCertificatePic,

                holderFile: this.ruleForm.cardholderPic,
                idCardNum:
                    this.ruleForm.idCardNum == ""
                        ? this.ruleForm.passportNum
                        : this.ruleForm.idCardNum,
                name:
                    this.ruleForm.idCardName == ""
                        ? this.ruleForm.passportName
                        : this.ruleForm.idCardName,
                isDefault: 1,
                // code: this.ruleForm.passbookVercode,
                mobile: this.ruleForm.accountTel,
                senderMobile: this.ruleForm.accountTel,
                senderType: this.ruleForm.codCertType,
                certType:
                    this.ruleForm.codCertType === "1" ? this.ruleForm.certType : "",
                contactName: this.ruleForm.contactName,
            };
            certAgentCodInfoAndType(data).then(res => {
                this.$bvModal.msgBoxOk("提交成功", {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "去寄件",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                }).then(() => {
                    this.$router.push({
                        path: '/pos'
                    })
                })
            })
        },
        // 税务证书
        updateImage4(val) {
            this.ruleForm.TaxfileCertificatePic = val
            this.imgUrl4 = val
        },
        // 企业注册证书
        updateImage2(val) {
            this.ruleForm.companyCertificatePic = val
            this.imgUrl2 = val
        },
        // 上传存折照片
        updateImage1(val) {
            this.ruleForm.passportPic = val
            this.imgUrl1 = val
        },
        // 上传身份证正面照片 公司法人代表
        updateImage(val) {
            this.ruleForm.cardholderPic = val
            this.imgUrl = val

        },
    }


}
</script>

<style scoped>
.noticeContent {
    height: 20vh;
    overflow: auto;
}

.noticeContent h3 {
    font-size: 20px;
    line-height: 36px;
    color: #303133;
    text-align: center;
}

.noticeContent p {
    line-height: 28px;
    color: #606266;
}

.noticeContent h4 {
    font-size: 16px;
    display: inline;
    font-weight: 600;
    line-height: 36px;
    color: #303133;
}
</style>
